import { SharedStrings } from '@colonist/types';
import { UIImagePathController } from '../UIEnums.ts';
export const ACTIVE_OPACITY = 1;
export const INACTIVE_OPACITY = 0.4;
export function isCloseTo(value1, value2, margin) {
    if (value1 + margin > value2 && value1 - margin < value2) {
        return true;
    }
    return false;
}
export function logError(functionName, logs) {
    const text = 'Something went wrong, please contact admins at ' + SharedStrings.SUPPORT_EMAIL + '  with copying this log' + ' and explaining what actions you took right before this error.';
    /* eslint-disable no-console */ console.log(text);
    /* eslint-enable no-console */ logDebugInfo(functionName, logs);
}
export function logDebugInfo(functionName, logs) {
    /* eslint-disable no-console */ console.info(functionName);
    for (const log of logs){
        console.info(log);
    }
/* eslint-enable no-console */ }
export function removeURLParams() {
    window.history.replaceState(null, '', window.location.pathname + window.location.hash);
}
// https://stackoverflow.com/a/5298684
export function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
}
export function getLobbyImagePath(img) {
    return UIImagePathController.getImgPath(img);
}
